module.exports = __webpack_public_path__ + "img/logo2.d8bb58d4.png";